import queryString from 'query-string';
import dash_api from '../../support/dash_api';
import { ReduxAsyncAction } from '../../support/utils';
import { LinkFilterTypes } from '../../enums/LinkFilterType';
import NotificationActions from '../NotificationActions';
import type { QueryParameters } from './Types/QueryParameters';

const ERROR_MESSAGE = 'An error occurred. Please refresh the page';
const LINK_MANAGER_QUERY_PATH = '/link/manager/query';
const ERROR = 'error';
const V1 = '/v1';

const FetchLinksByQuery = new ReduxAsyncAction('FETCH_LINKS_BY_QUERY');
FetchLinksByQuery.registerRequest(async (parameters: Partial<QueryParameters>) => {
  try {
    const {
      page,
      size,
      dateTo,
      dateFrom,
      orderBy,
      orderDirection,
      fetchLinkObject,
      archived,
      linkType,
      fetchCollectionCount,
    } = parameters;

    const {
      campaigns,
      channels,
      quickLinkTemplateIds,
      features,
      tags,
      searchString,
      topics,
      analyticsDateTo,
      analyticsDateFrom,
      unique,
      $3p,
      collectionIds,
    } = parameters;

    const urlQuery = queryString.stringify({
      page: page,
      page_size: size,
      date_from: dateFrom,
      date_to: dateTo,
      order_by: orderBy,
      order_direction: orderDirection,
      archived: archived,
      fetch_link_object: fetchLinkObject,
      link_type: linkType === LinkFilterTypes.AllLinks ? undefined : linkType,
      fetch_collection_count: fetchCollectionCount,
    });

    const body = {
      campaigns: campaigns,
      channels: channels,
      features: features,
      tags: tags,
      topics: topics,
      search_string: searchString,
      quick_link_template_ids: quickLinkTemplateIds,
      analytics: true,
      analytics_date_to: analyticsDateTo,
      analytics_date_from: analyticsDateFrom,
      unique: unique,
      $3p: $3p,
      collectionId: collectionIds,
    };

    const URI = `${V1}${LINK_MANAGER_QUERY_PATH}?${urlQuery}`;

    return await dash_api.post(URI, body);
  } catch (e) {
    NotificationActions.showNotification(ERROR_MESSAGE, ERROR);
    throw e;
  }
});
export const FETCH_LINKS_BY_QUERY: any = FetchLinksByQuery.constants;
export const fetchLinksByQuery = FetchLinksByQuery.request;
